document.addEventListener('DOMContentLoaded', () => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-kf-product-hero]').forEach((hero) => {
    const thumbs = Array.from(hero.querySelectorAll('[data-thumb-index]'));
    const tiles = Array.from(hero.querySelectorAll('[data-gallery-index]'));
    const routineOptions = Array.from(hero.querySelectorAll('[data-kf-routine-option]'));
    const purchaseOptions = Array.from(hero.querySelectorAll('[data-kf-purchase-option]'));
    const variantInput = hero.querySelector('[data-kf-routine-variant-input]');
    const planInput = hero.querySelector('[data-kf-routine-plan-input]');
    const submitButton = hero.querySelector('[data-kf-routine-submit]');
    const submitLabel = hero.querySelector('[data-kf-routine-submit-label]');
    const fallbackLink = hero.querySelector('[data-kf-routine-link]');
    const noteWrap = hero.querySelector('[data-kf-routine-note]');
    const noteText = hero.querySelector('[data-kf-routine-note-text]');
    const purchaseLabels = {
      onetime: hero.querySelector('[data-kf-purchase-label="onetime"]'),
      subscribe: hero.querySelector('[data-kf-purchase-label="subscribe"]'),
    };
    const purchasePrices = {
      onetime: hero.querySelector('[data-kf-purchase-price="onetime"]'),
      subscribe: hero.querySelector('[data-kf-purchase-price="subscribe"]'),
    };
    const purchaseBadges = {
      onetime: hero.querySelector('[data-kf-purchase-badge="onetime"]'),
      subscribe: hero.querySelector('[data-kf-purchase-badge="subscribe"]'),
    };
    const soldOutLabel = hero.querySelector('[data-kf-routine-cta]')?.dataset.soldOutLabel || 'Sold out';

    const setActiveThumb = (index) => {
      thumbs.forEach((thumb) => {
        const isActive = Number(thumb.dataset.thumbIndex) === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', String(isActive));
        thumb.setAttribute('aria-pressed', String(isActive));
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.thumbIndex);
        const targetTile = tiles.find((tile) => Number(tile.dataset.galleryIndex) === index);

        setActiveThumb(index);

        if (targetTile) {
          targetTile.scrollIntoView({
            behavior: prefersReducedMotion ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'nearest',
          });
        }
      });
    });

    if (window.IntersectionObserver && thumbs.length && tiles.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visibleEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (!visibleEntry) return;

          const activeIndex = Number(visibleEntry.target.dataset.galleryIndex);
          if (activeIndex) setActiveThumb(activeIndex);
        },
        {
          rootMargin: '-25% 0px -25% 0px',
          threshold: [0.2, 0.45, 0.7],
        }
      );

      tiles.forEach((tile) => observer.observe(tile));
    }

    const getSelectedBundle = () => routineOptions.find((option) => option.checked);
    const getSelectedPurchase = () =>
      purchaseOptions.find((option) => option.checked)?.value || 'subscribe';

    const updatePurchaseOptionDisplay = (bundle) => {
      if (!bundle) return;

      const values = {
        onetime: {
          label: bundle.dataset.onetimeLabel || 'One-time purchase',
          price: bundle.dataset.onetimePrice || '',
          badge: bundle.dataset.onetimeBadge || '',
        },
        subscribe: {
          label: bundle.dataset.subscribeLabel || 'Subscribe & Save',
          price: bundle.dataset.subscribePrice || '',
          badge: bundle.dataset.subscribeBadge || '',
        },
      };

      ['onetime', 'subscribe'].forEach((key) => {
        if (purchaseLabels[key]) purchaseLabels[key].textContent = values[key].label;
        if (purchasePrices[key]) purchasePrices[key].textContent = values[key].price;

        if (purchaseBadges[key]) {
          const badgeText = values[key].badge.trim();
          purchaseBadges[key].textContent = badgeText;
          purchaseBadges[key].hidden = badgeText.length === 0;
        }
      });
    };

    const applyRoutineSelection = () => {
      const bundle = getSelectedBundle();
      if (!bundle) return;

      const purchaseType = getSelectedPurchase();
      const isSubscribe = purchaseType === 'subscribe';
      const isAvailable = bundle.dataset.available !== 'false';
      const nextVariantId = bundle.dataset.variantId || '';
      const nextPlanId = isSubscribe ? bundle.dataset.subscribePlan || '' : '';
      const nextCtaText = isSubscribe
        ? bundle.dataset.subscribeCta || soldOutLabel
        : bundle.dataset.onetimeCta || soldOutLabel;
      const nextCtaUrl = bundle.dataset.ctaUrl || '';

      if (variantInput) variantInput.value = nextVariantId;
      if (planInput) planInput.value = nextPlanId;

      if (submitButton) {
        submitButton.disabled = !isAvailable || !nextVariantId;
      }

      if (submitLabel) {
        submitLabel.textContent = isAvailable && nextVariantId ? nextCtaText : soldOutLabel;
      }

      if (fallbackLink && nextCtaUrl) {
        fallbackLink.href = nextCtaUrl;
        const linkLabel = fallbackLink.querySelector('[data-kf-routine-submit-label]');
        if (linkLabel) {
          linkLabel.textContent = isAvailable && nextVariantId ? nextCtaText : soldOutLabel;
        }
      }

      if (noteWrap && noteText) {
        noteText.textContent = '';
        noteWrap.hidden = true;
      }
    };

    const syncBundleSelection = () => {
      const activeBundle = getSelectedBundle();
      if (!activeBundle) return;
      const subscribeOption = purchaseOptions.find((input) => input.value === 'subscribe');
      if (subscribeOption) subscribeOption.checked = true;
      updatePurchaseOptionDisplay(activeBundle);
      applyRoutineSelection();
    };

    routineOptions.forEach((option) => {
      option.addEventListener('change', syncBundleSelection);
      option.addEventListener('input', syncBundleSelection);
      option.addEventListener('click', () => {
        window.requestAnimationFrame(syncBundleSelection);
      });
    });

    purchaseOptions.forEach((option) => {
      option.addEventListener('change', applyRoutineSelection);
    });

    const selectedBundle = getSelectedBundle();
    updatePurchaseOptionDisplay(selectedBundle);
    applyRoutineSelection();

    /* Bypass app-injected form fields (subs_type_*, subs_interval, etc.) by intercepting
       submit and posting directly to /cart/add.js with only our id+selling_plan+quantity. */
    const productForm = hero.querySelector('.kf-prod__cta-form');
    if (productForm) {
      productForm.addEventListener('submit', (event) => {
        const variantId = variantInput && variantInput.value;
        if (!variantId) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        const payload = new FormData();
        payload.append('id', variantId);
        payload.append('quantity', '1');
        const planId = planInput && planInput.value;
        if (planId) payload.append('selling_plan', planId);

        if (submitButton) {
          submitButton.disabled = true;
          submitButton.classList.add('is-loading');
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: payload,
        })
          .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
          .then(({ ok, data }) => {
            if (!ok) {
              console.error('cart/add error', data);
              alert(data.description || data.message || 'Could not add to cart');
              return;
            }
            window.location.href = '/cart';
          })
          .catch((error) => {
            console.error('cart/add fetch failed', error);
            alert('Could not add to cart. Please try again.');
          })
          .finally(() => {
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.classList.remove('is-loading');
            }
          });
      }, true);
    }
  });
});
